import { Color } from './color';
/**
 * △
 */
export const HollowTriangle = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'stroke', symbol: 'triangle' }, options), context);
};
HollowTriangle.props = Object.assign({ defaultMarker: 'hollowTriangle' }, Color.props);
//# sourceMappingURL=hollowTriangle.js.map